import { graphql } from "@apollo/client/react/hoc";
import { gql } from "@apollo/client";

import { handleErrors } from "~/src/utils/errors";

const GET_AVAILABLE_MEMBER_TYPES = gql`
  query getAvailableMemberTypes {
    account {
      id
      memberTypesAvailableForAccount {
        isCasualMemberTypeAvailable
        isPermanentMemberTypeAvailable
        isAgencyMemberTypeAvailable
        isContractorLimitedCompanyMemberTypeAvailable
        isContractorUmbrellaCompanyMemberTypeAvailable
        isContractorSelfEmployedMemberTypeAvailable
      }
    }
  }
`;

export default graphql(GET_AVAILABLE_MEMBER_TYPES, {
  props: handleErrors(({ data: { loading, account } }) => ({
    memberTypesAvailableForAccount: account?.memberTypesAvailableForAccount,
    isLoadingAccountMemberTypes: loading
  }))
});
